import type { State } from '../typings'

export type CloseAction = { type: 'close' }

export const closeAction = (state: State) => ({ ...state, mode: undefined })

export const closeActionCreator = (): CloseAction => ({ type: 'close' })
